import { initializeApp } from 'firebase/app';
import { getFirestore } from "firebase/firestore";

let firebaseConfig = {
	apiKey: "AIzaSyDNvsYXvrpxf1DrhLL8JL-LfUzRecd312s",
	authDomain: "superwall.firebaseapp.com",
	projectId: "superwall",
	storageBucket: "superwall.appspot.com",
	messagingSenderId: "1073058607966",
	appId: "1:1073058607966:web:d5c656c52ff4fb5aa955cf",
	measurementId: "G-Z8XPHZ9NGB"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);